import { render, staticRenderFns } from "./informacoes-ciclos-totais.vue?vue&type=template&id=b0769a5c"
import script from "./informacoes-ciclos-totais.vue?vue&type=script&lang=js"
export * from "./informacoes-ciclos-totais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports